import React, { useCallback, useMemo, useState } from 'react';
import '../../../utils/default.css';
import AdminTheme from '../../AdminTheme';
import SliderHeader, { SliderHeaderContext } from '../Slider/SliderHeader';

export default function SliderDisplay({ children, persistentHeader = false }) {
   const [header, setHeader] = useState(null);
   const updateHeader = useCallback((next, preserve) => {
      setHeader(current => preserve && current ? current : next);
   }, []);
   const shell = useMemo(() => ({ updateHeader }), [updateHeader]);
   return <AdminTheme>
      <div className="appContainer admin-ui">
         <div className="sliderContainer">
            {persistentHeader ? <SliderHeaderContext.Provider value={shell}>
               <div className="Slider" style={{ top: 0, height: '100%' }}>
                  <SliderHeader {...(header || { name: 'Admin', canGoBack: false })} />
                  {children}
               </div>
            </SliderHeaderContext.Provider> : children}
         </div>
      </div>
   </AdminTheme>;
}
